import { isNull, recipe } from "@mealplan/powersync";

/**
 * ┌─────────────────────────────────────────────────────────────────────────┐
 * │ SOFT-DELETE — CAPA LIVE CENTRALIZADA (choke point único)                  │
 * └─────────────────────────────────────────────────────────────────────────┘
 *
 * Este módulo es el ÚNICO lugar donde el invariante «fila viva = `deleted_at IS
 * NULL`» se expresa para las tablas con papelera de este repo (`recipe`). Toda
 * lectura viva compone estos predicados (los builders de dominio en
 * recipes/meal-plan/shopping los importan de aquí). Las ÚNICAS lecturas que ven
 * filas borradas son la papelera (`getTrashedRecipesQuery`), el resolutor de
 * nombres del feed de actividad (que legítimamente muestra nombres de recetas ya
 * borradas) y algún lookup id-scoped inofensivo, todos declarados en la
 * whitelist del guard (`guard-manifest.ts`).
 *
 * ¿Por qué centralizar? El invariante disperso fue la familia de bugs #1 de la
 * campaña (stats/contadores/joins/PATCH que ignoraban `deleted_at`). Con un
 * choke point único + guard anti-regresión, añadir una lectura cruda de estas
 * tablas fuera de la whitelist ROMPE el build (ver
 * `live/__tests__/live-access-guard.test.ts`).
 *
 * NOTA de esquema (meal-planner): sólo `recipe` lleva `deleted_at`.
 * `recipe_ingredient` NO es soft-delete: es hijo en cascada por FK (`ON DELETE
 * cascade`) y se conserva intacto mientras la receta esté en la papelera
 * (reaparece al restaurar) y cae al purgar su `recipe` padre.
 */

/**
 * Predicados de «receta viva»: la receta no está en la papelera. Se aplica en
 * TODA vista/consulta viva de `recipe`. `recipe` no tiene padre con papelera, así
 * que basta con el propio `deleted_at IS NULL`.
 */
export function liveRecipeFilters() {
  return [isNull(recipe.deleted_at)];
}
